export const Links = {
  intern: {
    start: {
      href: "#/startpagina",
      text: "Startpagina",
      title: "Naar de startpagina.",
    },
    documentenlijst: {
      href: "#/documenten",
      text: "Lijst",
      title: "Naar de documentenlijst.",
    },
    aanleveren: {
      href: "#/aanleveren",
      text: "Publiceren",
      title: "Start hier met het publiceren van uw documenten.",
    },
    over: {
      href: "#/over",
      text: "Over het aanleverloket ",
      title: "Lees hier meer over het aanleverloket.",
    },
    apidocs: {
      href: "#/api-doc",
      text: "API Documentatie",
      title: "Bekijk de API documentatie.",
    },
  },
  subnav: {
    documentenlijst: {
      href: "#/documenten",
      text: "Verwerkt",
      title: "Naar de documentenlijst.",
    },
    verwerkingsoverzicht: {
      href: "#/documenten/verwerkingsoverzicht",
      text: "Niet verwerkt",
      title: "Naar het verwerkingsoverzicht.",
    },
  },
  extern: {
    handleiding: {
      href: "https://www.koopoverheid.nl/documenten/instructies/2023/05/11/handleiding-kamerstukkenmodule",
      text: "handleiding Kamerstukkenmodule.",
      title: "Lees hier meer over het aanleverloket.",
    },
    portaal: {
      href: "https://open.overheid.nl",
      text: "Ga naar het portaal ",
      title: "Op het portaal kunt u de aangeleverde documenten vinden.",
    },
    Aanlever_API: {
      href: "https://solution-architectuur-gwv-15ded5.gitlab.io/docs/category/woo-api/v2.0",
      title: "Aanlever API",
      text: "Aanlever API",
      external: true,
      newWindow: true,
    },
    PUF: {
      href: "",
      title: "Fair Use Policy",
      text: "Fair Use Policy",
      external: true,
      newWindow: true,
    },
  },
};
